import React from 'react'
import './style.css'
import { NavLink, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { handleLogout } from '../../redux/slices/authSlice'

const SuperAdminSidebar = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleLogoutHere = () => {
        dispatch(handleLogout());
        navigate("/signin");
    }

    return (
        <ul className="admin-sidebar">
            <div className="sidebar-section">
                <span>Main</span>
            </div>

            <li>
                <NavLink to="/admin/dashboard" className={({ isActive }) => isActive ? 'active-link' : ''}>
                    <i className="fa-solid fa-gauge-high"></i> Dashboard
                </NavLink>
            </li>

            <div className="sidebar-divider"></div>

            <div className="sidebar-section">
                <span>Management</span>
            </div>

            <li>
                <NavLink to='/admin/users' className={({ isActive }) => isActive ? 'active-link' : ''}>
                    <i className="fa-solid fa-users"></i> Users
                </NavLink>
            </li>

            <li>
                <NavLink to="/admin/professionals" className={({ isActive }) => isActive ? 'active-link' : ''}>
                    <i className="fa-solid fa-user-tie"></i> Professionals
                </NavLink>
            </li>

            <li>
                <NavLink to="/admin/corporates" className={({ isActive }) => isActive ? 'active-link' : ''}>
                    <i className="fa-solid fa-building"></i> Corporates
                </NavLink>
            </li>

            <li>
                <NavLink to='/admin/profile/review' className={({ isActive }) => isActive ? 'active-link' : ''}>
                    <i className="fa-solid fa-user-check"></i> Profile Review
                </NavLink>
            </li>

            <li>
                <NavLink to='/admin/subscriptions' className={({ isActive }) => isActive ? 'active-link' : ''}>
                    <i className="fa-solid fa-credit-card"></i> Subscriptions
                </NavLink>
            </li>

            <div className="sidebar-divider"></div>

            <div className="sidebar-section">
                <span>System</span>
            </div>

            <li>
                <NavLink to='/admin/settings' className={({ isActive }) => isActive ? 'active-link' : ''}>
                    <i className="fa-solid fa-gear"></i> Settings
                </NavLink>
            </li>

            <li>
                <a className="logout-link" style={{ cursor: 'pointer' }} onClick={handleLogoutHere}>
                    <i className="fa-solid fa-right-from-bracket"></i> Logout
                </a>
            </li>
        </ul>
    )
}

export default SuperAdminSidebar